export default "__VITE_ASSET__RiI16oeb__"